<div *ngIf="isOpened && !disabled" class="list"
     [class.list--topPosition]="!showListOnTop"
     [class.list--bottomPosition]="showListOnTop">
    <div *ngFor="let option of optionsList"
         (click)="selectPageSize(option)"
         [ngClass]="{ 'active' : selectedValue === option[keyName] }"

         class="option">{{ option[keyName] }}</div>
</div>

<div class="head" [class.disabled]="disabled" (click)="!disabled && toggleDropdown()">
    <span *ngIf="!selectedValue" class="dropdown-placeholder">
        {{ placeholder }}
    </span>
    <span>{{ selectedValue }}</span>
    <i class="arrow-icon icon-arrow-expand" [ngClass]="{'opened': isOpened}"></i>
</div>
